import { uniqueId } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Field } from 'redux-form';
import UploadImageBtnField from '../../../../../../../../helpers/Fields/UploadImageBtnField';
import UploadImageField from '../../../../../../../../helpers/Fields/UploadImageField';
import LineLabel from './components/LineLabel/LineLabel';
import './style.scss';
let isMouseDown, context, canvas, startX, startY, block;

export class AnswerType6 extends Component {

  constructor(props) {
    super(props)
  
    this.ref = React.createRef();
    this.blockRef = React.createRef();

    this.state = {
       
    }
  }

  getXY = (e) => {
    const position = canvas.getBoundingClientRect();
    const x = (e.pageX - position.left);
    const y = (e.clientY - position.top);
    return {
      x, y 
    }
  }

  drawLine = (e) =>  {
 
    const {answers} = this.props;
    const items = answers.variants || [];
    if (isMouseDown) {
      const {x, y} = this.getXY(e);

      context.clearRect(0,0,canvas.width,canvas.height);
      this.moveLine(startX, startY, x, y)
      this.reloadLines(items);
      this.moveBlock(x, y, startX, startY)
    }
  }

  moveBlock = (x, y, e_x, e_y) => {
    const width = 200;
    const height = 50;

    const tmpX = x < e_x ? x - width : x;
    const tmpY = y;

    context.beginPath();
    context.fillStyle = 'gray'
    context.rect(tmpX, tmpY-25, width, height)
    context.fill();
    context.closePath();

    context.beginPath();
    context.fillStyle = 'rgba(255,255,255,1)';
    context.rect(tmpX+1, tmpY-24, width-2, height-2)
    context.fill();
    context.closePath();

  };

  moveLine = (s_x, s_y, e_x, e_y) => {
    try {
      context.beginPath();
      context.setLineDash([8, 5]);
      context.moveTo(s_x, s_y);
      context.lineTo(e_x, e_y);
      context.stroke();
      context.closePath();
    } catch (error) {
    }
  }

  endLine = (e) => {
    const {answers, rootChange} = this.props;
    const items = answers.variants || [];
    const {x: endX, y: endY} = this.getXY(e);
    isMouseDown = false;
    // if(canvas.width - 200 > endX && 200 < endX && canvas.height - 25 > endY && 25 < endY){
    if(
      (startX <= endX ? (canvas.width > endX + 200 && 0 < endX) : (canvas.width > endX && 200 < endX))
        &&
      (startY <= endY ? (canvas.height > endY + 25 && 25 < endY) : (canvas.height > endY && 25 < endY))
      //  canvas.height - 50 > endY && 50 < endY
    ){
      rootChange('answers', {
        ...answers,
        variants: [...items, {_id: uniqueId('variant-') + Date.now(), startX, startY, endX, endY, value: '' }]
      })
      // setItems([...items, {startX, startY, endX, endY }])
    } else {
      context.clearRect(0,0,canvas.width,canvas.height);
      this.reloadLines(items);
    }
    
  }

  deleteItem = (index) => {
    const {answers, rootChange} = this.props;
    const items = answers.variants || [];
    const tmp = items.filter((_i, i) => i != index);
    context.clearRect(0,0,canvas.width,canvas.height);
    this.reloadLines(tmp);
    rootChange('answers', {
      ...answers,
      variants: tmp
    })
    // setItems(tmp)
  }

  reloadLines = (tmp) => {
    tmp.forEach(item => {
      this.moveLine(item.startX, item.startY, item.endX, item.endY)
    })
  }

  componentDidMount(){
    
    if(this.ref.current){
      canvas = this.ref.current;
      block = this.blockRef.current;
      context = canvas.getContext("2d");
      const {answers, rootChange} = this.props;
      const items = answers.variants || [];
      this.reloadLines(items);
    }
  }

  render() {
    const {answers, rootChange} = this.props;
    const items = answers.variants || [];
    const image = answers.image || '';
    return (
      <div className='AnswerType6'>
        <Field name='answers.image' component={UploadImageBtnField} />
        <div className='block' ref={this.blockRef} style={{backgroundImage: `url(${image})`}}>
          <canvas 
            ref={this.ref} 
            width="900" 
            height='500' 
            onMouseDown={(e) => {
              isMouseDown = true;
              const {x, y} = this.getXY(e);
              startX = x;
              startY = y; 
              console.log("🚀 ~ file: AnswerType6.jsx ~ line 119 ~ AnswerType6 ~ render ~ startY", startY, e.clientY, e.clientY, e.movementY)
            }}
            onMouseMove={this.drawLine}
            onMouseUp={this.endLine}
          />
          {items.map((item, index) => <LineLabel key={'line_' + index} canvas={canvas} item={item} onChange={v => {

            rootChange('answers',{
              ...answers,
              variants: [...items.map((_i, i) => i == index ? {..._i, value: v} : {..._i})]
            })
          }} deleteItem={() => {
            this.deleteItem(index);
          }} />)}
        </div>
      </div>
    )
  }
}

export default AnswerType6


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Question/components/QuestionModal/components/components/Answers/components/AnswerType6/AnswerType6.jsx